<template>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-icon"
      @click.prevent="toggleModal"
      @keydown.enter.stop="toggleModal"
      ref="filterBtn"
      tabindex="0"
    >
      <span class="icon icon-filter"></span>
    </button>
    <base-modal
      :is-show="showModal"
      class="filter-modal"
      mode="reverse"
      @close="closeModal"
      @confirm="confirm"
      @cancel="cancel"
    >
      <template #header>{{ title }}</template>
      <template #body>
        <slot></slot>
      </template>
    </base-modal>
  </div>
</template>

<script>
import('@/styles/components/filter.less')

export default {
  name: 'PageCommonFilter',
  components: {
    BaseModal: () => import('@/base/BaseModal.vue')
  },
  props: {
    title: {
      type: String,
      default: function() {
        return this.$t('filter.filter')
      }
    }
  },
  data: () => ({
    showModal: false
  }),
  computed: {},
  methods: {
    toggleModal() {
      this.showModal = !this.showModal
      if (this.showModal) {
        this.$refs.filterBtn.blur()
        this.$emit('open:filter')
      }
    },
    closeModal() {
      this.showModal = false
    },
    confirm() {
      this.$emit('confirm')
      this.closeModal()
    },
    cancel() {
      this.$emit('cancel')
    }
  }
}
</script>
